import React, { useState } from "react";
import {
  FaGlassCheers,
  FaHeart,
  FaBookmark,
  FaClock,
  FaChevronDown,
  FaChevronUp,
  FaCheckCircle,
  FaWhatsapp,
  FaArrowRight,
  FaEnvelope,
  FaTimes,
  FaCocktail,
} from "react-icons/fa";

export const BlogSinglePage2 = () => {
  const [openRecipe, setOpenRecipe] = useState(1);
  const [selectedBlog, setSelectedBlog] = useState(null);

  const recipes = [
    {
      id: 1,
      title: "Mojito Clásico Fácil",
      content:
        "Menta fresca, azúcar, limón, ron blanco, hielo y soda. Machaca la menta suavemente, mezcla ingredientes y sirve bien frío.",
    },
    {
      id: 2,
      title: "Daiquiri de Fresa Fácil",
      content:
        "Fresas maduras, ron blanco, limón, azúcar y hielo picado. Licúa todo hasta lograr textura cremosa.",
    },
    {
      id: 3,
      title: "Tip Profesional de Bartender",
      content:
        "Enfría siempre la copa antes de servir. Esto mejora aroma, textura y presentación del cóctel.",
    },
  ];

  const related = [
    {
      title: "3 tragos elegantes para eventos",
      img: "https://images.pexels.com/photos/602750/pexels-photo-602750.jpeg?auto=compress&cs=tinysrgb&w=600",
      desc:
        "Conoce recetas premium ideales para celebraciones, reuniones y presentaciones modernas.",
    },
    {
      title: "Decoración profesional de bebidas",
      img: "https://images.pexels.com/photos/338713/pexels-photo-338713.jpeg?auto=compress&cs=tinysrgb&w=600",
      desc:
        "Aprende garnish, cortes de frutas, escarchado y detalles visuales impactantes.",
    },
    {
      title: "Cómo iniciar como bartender",
      img: "https://images.pexels.com/photos/696218/pexels-photo-696218.jpeg?auto=compress&cs=tinysrgb&w=600",
      desc:
        "Descubre herramientas, actitud profesional y primeros pasos en la coctelería.",
    },
  ];

  return (
    <div className="bg-[#f5f6fa] min-h-screen">
      {/* HERO */}
      <section className="relative h-[650px] overflow-hidden">
        <img
          src="https://images.pexels.com/photos/1189261/pexels-photo-1189261.jpeg?auto=compress&cs=tinysrgb&w=1600"
          alt="Cevafest"
          className="w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/20"></div>
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent"></div>

        <div className="absolute top-0 left-0 w-full h-2 flex">
          <div className="w-1/3 bg-red-600"></div>
          <div className="w-1/3 bg-yellow-400"></div>
          <div className="w-1/3 bg-blue-800"></div>
        </div>

        <div className="absolute inset-0 max-w-7xl mx-auto px-6 flex items-center">
          <div className="max-w-3xl text-white">
            <span className="bg-yellow-400 text-black px-4 py-2 rounded-full text-sm font-bold">
              CEVAFEST
            </span>

            <h1 className="text-6xl md:text-4xl font-extrabold leading-tight mt-6">
              Aprende Coctelería con Cevatur
            </h1>

            <p className="text-xl text-gray-200 mt-6">
              Descubre recetas modernas, técnicas profesionales y creatividad
              detrás de cada bebida.
            </p>

            <div className="flex flex-wrap gap-4 mt-8">
              <InfoBtn icon={<FaClock />} text="6 min lectura" />
              <InfoBtn icon={<FaHeart />} text="Favorito" />
              <InfoBtn icon={<FaBookmark />} text="Guardar" />
            </div>
          </div>
        </div>
      </section>

      {/* CONTENIDO */}
      <section className="max-w-7xl mx-auto px-6 py-12 grid grid-cols-3 gap-8">
        {/* IZQUIERDA */}
        <div className="col-span-2 space-y-8">
          <div className="bg-white rounded-3xl shadow-lg p-8">
            <h2 className="text-4xl font-bold text-blue-950 mb-5">
              La mixología también es arte
            </h2>

            <p className="text-gray-600 text-lg leading-relaxed">
              Cada cóctel combina técnica, presentación y equilibrio de sabores.
            </p>

            <img
              src="https://images.pexels.com/photos/7269212/pexels-photo-7269212.jpeg?auto=compress&cs=tinysrgb&w=1200"
              alt="Cocteles"
              className="w-full h-[420px] object-cover rounded-2xl mt-8"
            />
          </div>

          <div className="bg-white rounded-3xl shadow-lg p-8">
            <div className="flex items-center gap-4 mb-8">
              <FaCocktail className="text-red-600 text-3xl" />
              <h3 className="text-3xl font-bold text-blue-950">
                Recetas Interactivas
              </h3>
            </div>

            <div className="space-y-4">
              {recipes.map((item) => (
                <div
                  key={item.id}
                  className="border border-gray-200 rounded-2xl overflow-hidden"
                >
                  <button
                    onClick={() =>
                      setOpenRecipe(openRecipe === item.id ? null : item.id)
                    }
                    className="w-full flex justify-between items-center p-5"
                  >
                    <div className="flex items-center gap-4">
                      <span className="w-9 h-9 rounded-full bg-red-600 text-white flex items-center justify-center font-bold">
                        {item.id}
                      </span>

                      <span className="font-bold text-blue-950">
                        {item.title}
                      </span>
                    </div>

                    {openRecipe === item.id ? (
                      <FaChevronUp />
                    ) : (
                      <FaChevronDown />
                    )}
                  </button>

                  {openRecipe === item.id && (
                    <div className="px-6 pb-6 text-gray-600">
                      {item.content}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* DERECHA */}
        <div className="space-y-8">
          <div className="bg-white rounded-3xl shadow-lg p-8">
            <h3 className="text-3xl font-bold text-blue-950 mb-6">
              Aprende Hoy
            </h3>

            <div className="space-y-4">
              {[
                "Preparación de cócteles clásicos",
                "Decoración premium",
                "Manejo de barra",
                "Servicio profesional",
              ].map((item, i) => (
                <div key={i} className="flex items-center gap-3">
                  <FaCheckCircle className="text-red-600" />
                  {item}
                </div>
              ))}
            </div>
          </div>

          {/* BLOGS RELACIONADOS */}
          <div className="bg-white rounded-3xl shadow-lg p-8">
            <h3 className="text-3xl font-bold text-blue-950 mb-6">
              Blogs Relacionados
            </h3>

            <div className="space-y-5">
              {related.map((item, i) => (
                <div
                  key={i}
                  onClick={() => setSelectedBlog(item)}
                  className="flex gap-4 group cursor-pointer hover:bg-gray-50 p-3 rounded-xl transition"
                >
                  <img
                    src={item.img}
                    alt=""
                    className="w-24 h-24 rounded-xl object-cover"
                  />

                  <div>
                    <h4 className="font-bold text-blue-950 group-hover:text-red-600 transition">
                      {item.title}
                    </h4>

                    <span className="flex items-center gap-2 text-red-600 mt-2 text-sm font-semibold">
                      Leer más <FaArrowRight />
                    </span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* NEWSLETTER */}
          <div className="bg-red-600 rounded-3xl shadow-xl p-8 text-white">
            <FaEnvelope className="text-4xl mb-5" />

            <h3 className="text-3xl font-bold">Síguenos en redes</h3>

            <p className="mt-3 text-red-100">
              Más recetas, eventos y novedades Cevafest.
            </p>

            <input
              type="email"
              placeholder="Tu correo electrónico"
              className="w-full mt-6 px-4 py-4 rounded-xl text-gray-800"
            />

            <a
              href="https://www.facebook.com/cevaturpiura"
              target="_blank"
              rel="noreferrer"
            >
              <button className="w-full mt-4 bg-blue-950 hover:bg-blue-900 py-4 rounded-xl font-bold transition">
                Suscribirme
              </button>
            </a>
          </div>
        </div>

        {/* CTA */}
        <div className="col-span-3">
          <div className="rounded-3xl bg-blue-950 text-white p-10 shadow-xl relative overflow-hidden">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-red-600 via-yellow-400 to-blue-700"></div>

            <h3 className="text-4xl font-bold">
              Aprende Bartender Profesional en Cevatur
            </h3>

            <p className="text-gray-300 mt-4 max-w-3xl text-lg">
              Domina barra, mixología, flair bartender y atención premium.
            </p>

            <div className="flex flex-wrap gap-4 mt-8">
              <a
                href="https://wa.me/51967575397"
                target="_blank"
                rel="noreferrer"
              >
                <button className="bg-green-500 hover:bg-green-600 px-8 py-4 rounded-xl font-bold flex items-center gap-3">
                  <FaWhatsapp />
                  Solicitar Información
                </button>
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* MODAL */}
      {selectedBlog && (
        <div className="fixed inset-0 bg-black/70 z-50 flex justify-center items-center px-4">
          <div className="bg-white max-w-2xl w-full rounded-3xl overflow-hidden shadow-2xl relative">
            <button
              onClick={() => setSelectedBlog(null)}
              className="absolute top-4 right-4 bg-red-600 text-white w-10 h-10 rounded-full flex items-center justify-center"
            >
              <FaTimes />
            </button>

            <img
              src={selectedBlog.img}
              alt=""
              className="w-full h-64 object-cover"
            />

            <div className="p-7">
              <h2 className="text-2xl font-bold text-blue-950">
                {selectedBlog.title}
              </h2>

              <p className="text-gray-600 mt-4 leading-7">
                {selectedBlog.desc}
              </p>

              <button
                onClick={() => setSelectedBlog(null)}
                className="mt-7 bg-blue-950 text-white px-6 py-3 rounded-xl font-bold"
              >
                Cerrar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

const InfoBtn = ({ icon, text }) => (
  <button className="border border-white/40 px-5 py-3 rounded-xl flex items-center gap-3 hover:bg-white hover:text-black transition">
    {icon}
    {text}
  </button>
);

export default BlogSinglePage2;